import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Menu, X, Globe } from 'lucide-react';
import { useState } from 'react';

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleLanguage = () => {
    const newLang = i18n.language === 'vi' ? 'en' : 'vi';
    i18n.changeLanguage(newLang);
  };

  const navLinks = [
    { to: '/', label: t('nav.home') },
    { to: '/products', label: t('nav.products') },
    { to: '/news', label: t('nav.news') },
    { to: '/contact', label: t('nav.contact') }
  ];

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center -ml-2 md:-ml-3 py-1 overflow-visible">
            <img 
              src="/logo.png" 
              alt="Tân Hưng Thịnh" 
              width="160"
              height="56"
              className="h-14 md:h-16 w-auto object-contain transform scale-[2.3] md:scale-[2.6] origin-left drop-shadow-md transition-transform duration-300 hover:scale-[2.4] md:hover:scale-[2.7]" 
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
              >
                {link.label}
              </Link>
            ))}
            <button
              onClick={toggleLanguage}
              aria-label="Đổi ngôn ngữ"
              className="flex items-center space-x-1 text-gray-700 hover:text-blue-600 transition-colors"
            >
              <Globe size={20} />
              <span className="font-medium">{i18n.language === 'vi' ? 'EN' : 'VI'}</span>
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            aria-label="Mở menu điều hướng"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden pb-4">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="block py-2 text-gray-700 hover:text-blue-600 transition-colors"
                onClick={() => setIsOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <button
              onClick={() => {
                toggleLanguage();
                setIsOpen(false);
              }}
              className="flex items-center space-x-1 py-2 text-gray-700 hover:text-blue-600 transition-colors"
            >
              <Globe size={20} />
              <span>{i18n.language === 'vi' ? 'English' : 'Tiếng Việt'}</span>
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
